export const FIRST_LAYER_MODAL = 'firstLayerModal';
export const SECOND_LAYER_MODAL = 'secondLayerModal';
export const THIRD_LAYER_MODAL = 'thirdLayerModal';
export const FOURTH_LAYER_MODAL = 'fourthLayerModal';